import { useFormik } from "formik"
import * as Yup from "yup"
import React from "react"
import {
  Card,
  Col,
  Container,
  Row,
  CardBody,
  CardTitle,
  Label,
  Button,
  Form,
  Input,
  InputGroup,
  FormFeedback,
  CardSubtitle,
  Spinner,
} from "reactstrap"
import { Link, useNavigate } from "react-router-dom"
import CustomHeaderTitle from "components/Common/CustomHeaderTitle"

const WarehouseForm = ({ onSubmit, loading, error, formMode, warehouse }) => {
  // Initialize Formik Hook for Validation
  // This hook manages form state and validation using Formik.
  const validationType = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      name: warehouse ? warehouse?.name : "",
    },
    validationSchema: Yup.object().shape({
      name: Yup.string().required("This name is required").min(3),
    }),
    onSubmit: values => {
      onSubmit(values)
    },
  })

  return (
    <Card>
      <CardBody>
        {/*
          CustomHeaderTitle Component Props:
          
          - loading: Boolean flag to display loading state
          - title: String to display as the header title
          - rowCount: Boolean to show/hide the row number selector
          - lgColumn: Number to control the width of columns based on layout needs
          - onChangeRowNumber: Callback function to handle row number selection change
          - orderingList: Boolean to show/hide ordering dropdown
          - onChangeOrdering: Callback function triggered when the ordering option is changed
          - searchBox: Boolean to show/hide search input box
          - onSearchHandler: Function called on key up in the search box
          - rightBtn: Boolean to show/hide right-side button (for example, a back button)
          - rightBtnTitle: String for setting the right button's label
          - rightBtnRoute: Route for the right button's navigation
          - exportBtn: Boolean to show/hide export button
          - onExportBtnClick: Callback for when the export button is clicked
          - exportBtnLoading: Boolean flag to show loading state during export functionality
          - advnacedSearchBtn: Boolean to show/hide advanced search button
          - advnacedSearchBtnTitle: String to display the advanced search button label
          - onAdvancedSearch: Callback function when the advanced search button is clicked (used to toggle collapse)
          - orderingOptions: Array of options to populate the ordering dropdown (value and name pair)
        */}
        <CustomHeaderTitle
          loading={loading}
          title={formMode === "Edit" ? "Edit Warehouse" : "Add Warehouse"}
          lgColumn={3}
          rowCount={false}
          orderingList={false}
          searchBox={false}
          rightBtn={true}
          rightBtnTitle={"Back"}
          rightBtnRoute={"/warehouse"}
        />

        <Form
          onSubmit={e => {
            e.preventDefault()
            validationType.handleSubmit()
            return false
          }}
        >
          <div className="mb-3">
            <Label className="form-label">Name</Label>
            <Input
              name="name"
              defaultValue={warehouse?.name}
              placeholder="Name"
              type="text"
              onChange={validationType.handleChange}
              onBlur={validationType.handleBlur}
              invalid={
                (validationType.touched.name && validationType.errors.name) ||
                error?.name?.[0]
                  ? true
                  : false
              }
            />
            {(validationType.touched.name && validationType.errors.name) ||
            error?.name?.[0] ? (
              <FormFeedback type="invalid">
                {validationType.errors.name || error?.name?.[0]}
              </FormFeedback>
            ) : null}
          </div>

          <div className="d-flex flex-wrap gap-2">
            <Button type="submit" color="primary" disabled={loading}>
              {loading
                ? "Please Wait..."
                : formMode === "Add"
                ? "Submit"
                : "Update"}
            </Button>
          </div>
        </Form>
      </CardBody>
    </Card>
  )
}

export default WarehouseForm
